import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const currentUser = localStorage.getItem('currentUser');
  if (currentUser) {
    return <Navigate to="/admin/index" replace />;
  }

  return children;
};

export default PublicRoute;
